import SuppliersGeneralInfoForm from '@/components/Suppliers/SuppliersGeneralInfoForm';
import { useCreateSupplier } from '@/core/domain/people/Suppliers/Suppliers.hooks';
import {
  Supplier,
  SupplierType,
} from '@/core/domain/people/Suppliers/Suppliers.types';
import { PurchaseCreateFormValues } from '@/core/domain/purchase/Purchase.types';
import { DateTimeFormat } from '@/utils/moment';
import { Collapse, Form, FormInstance, Modal } from 'antd';
import { useEffect, useState } from 'react';
import AddressForm from '../AddressModal/AddressForm';
import { AddressDefaultType } from '../AddressModal/types';
import PersonContactForm from '../MultipleContactModal/PersonContactForm';
import { LegalPersonContactFormInterface } from '../MultipleContactModal/types';

interface Props {
  visible: boolean;
  handleVisible: () => void;
  form?: FormInstance<PurchaseCreateFormValues>;
}

const SuppliersCreateModal = ({ visible, handleVisible, form }: Props) => {
  const [formSupplier] = Form.useForm<Supplier>();
  const [formAddress] = Form.useForm<AddressDefaultType>();
  const [formContact] = Form.useForm<LegalPersonContactFormInterface>();

  const [collapseKeys, setCollapseKeys] = useState<string | string[]>();

  const mutation = useCreateSupplier();

  useEffect(() => {
    setCollapseKeys('register');
  }, []);

  const handleSaveClick = async () => {
    try {
      if (!collapseKeys?.includes('register')) {
        handleVisible();
        return;
      }

      const formValuesSupplier = await formSupplier.validateFields();
      const formValuesAddress = await formAddress.validateFields();
      const formValuesContact = await formContact.validateFields();

      let obj: Supplier = {
        ...formValuesSupplier,
        active: true,
      };

      collapseKeys?.includes('address')
        ? (obj = {
            ...obj,
            address: {
              ...formValuesAddress,
            },
          })
        : undefined;

      collapseKeys?.includes('contact')
        ? (obj = {
            ...obj,
            contactList: [
              {
                ...formValuesContact,
                birthDate: formValuesContact.birthDate
                  ? formValuesContact.birthDate.format(DateTimeFormat)
                  : '',
                supplierId: formValuesContact.insurerId,
              },
            ],
          })
        : undefined;

      handleVisible();
      const newSupplier = await mutation.mutateAsync(obj);

      form?.submit();

      form?.setFieldsValue({
        supplier: {
          id: newSupplier.id,
          name: newSupplier.name,
        },
      });
    } catch (err) {}
  };

  const selectedPersonType = Form.useWatch('type', formSupplier);

  const onChange = (key: string | string[]) => {
    setCollapseKeys(key);
  };

  return (
    <Modal
      title="Cadastro de Fornecedores"
      visible={visible}
      onOk={handleSaveClick}
      onCancel={() => handleVisible()}
      width={'80%'}
      destroyOnClose
    >
      <Collapse
        defaultActiveKey={['register']}
        onChange={onChange}
        destroyInactivePanel={true}
      >
        <Collapse.Panel header="Cadastro" key="register">
          <SuppliersGeneralInfoForm form={formSupplier} />
        </Collapse.Panel>

        <Collapse.Panel header="Endereço" key="address">
          <AddressForm form={formAddress} simpleForm />
        </Collapse.Panel>

        <Collapse.Panel header="Contato" key="contact">
          <PersonContactForm
            personType={
              selectedPersonType === SupplierType.LegalPerson
                ? 'LegalPerson'
                : 'NaturalPerson'
            }
            form={formContact}
          />
        </Collapse.Panel>
      </Collapse>
    </Modal>
  );
};

export default SuppliersCreateModal;
